import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { useProductStore } from '../../contexts/product'
import { ModuleContext, ModulePills } from '../types'
import { ProductPills } from '../../components/ProductPills'

type Props = {
  module: ModulePills
  context: ModuleContext
}

export const PillsModule: FC<Props> = () => {
  const [{ product }] = useProductStore()

  const hasProductPills = Boolean(
    product.primaryProductPill || product.productPills?.length,
  )

  return hasProductPills ? (
    <Box data-testid="module-pills" mb={6}>
      <ProductPills
        primaryProductPill={product.primaryProductPill}
        productPills={product.productPills}
      />
    </Box>
  ) : null
}
